import React from "react";
import { useSocial } from "../../contexts/SocialContext";
import { useAuth } from "../../contexts/AuthContext";
import { Radio, Users, ChevronRight } from "lucide-react";

/**
 * A compact banner that appears when friends have active live sessions.
 * Designed to be placed in the app shell so it's visible across all views.
 */
export default function LiveSessionsBanner({ onNavigateToLive }) {
  const { user } = useAuth();
  const { activeLiveSessions, liveSession } = useSocial();

  // Don't show if: not logged in, already in a live session, or no active sessions
  if (!user || liveSession?.session || !activeLiveSessions?.length) return null;

  const count = activeLiveSessions.length;
  const firstSession = activeLiveSessions[0];

  return (
    <button
      onClick={onNavigateToLive}
      className="w-full flex items-center gap-3 px-4 py-2.5 bg-red-500/10 border-b border-red-500/20 hover:bg-red-500/15 transition-colors text-left"
    >
      <div className="flex items-center justify-center h-8 w-8 rounded-full bg-red-500/20 flex-shrink-0">
        <Radio className="h-4 w-4 text-red-500 animate-pulse" />
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-sm font-medium truncate">
          {count === 1
            ? `${firstSession.host_name} is live`
            : `${count} live sessions`}
        </p>
        <p className="text-xs text-muted-foreground truncate">
          {count === 1
            ? (firstSession.title || "Live workout")
            : `${firstSession.host_name} and ${count - 1} other${count > 2 ? "s" : ""}`}
          <span className="mx-1">·</span>
          <Users className="h-3 w-3 inline" />{" "}
          {activeLiveSessions.reduce((sum, s) => sum + (parseInt(s.participant_count) || 0), 0)}
        </p>
      </div>
      <ChevronRight className="h-4 w-4 text-muted-foreground flex-shrink-0" />
    </button>
  );
}
